import React from "react";
import { Redirect } from "react-router-dom";

import styles from "../style/Auth.module.css";

import logoSahadeviaWhiteText from "../images/sahadevia-white-text.png";
import splash from "../images/splash.svg";

export default class Auth extends React.Component {
  render() {
    if (!this.props.isReady) {
      return null;
    } else if (this.props.isConnected) {
      return <Redirect to="/home" />;
    }

    return (
      <div className={styles.auth}>
        <div className={styles.auth_left}>
          <img
            alt="background"
            src={splash}
            className={styles.auth_left_background}
          />
          <div className={styles.auth_left_top}>
            <img src={logoSahadeviaWhiteText} alt="logo" />
          </div>
          <div className={styles.auth_left_middle}>
            <h2>Vos factures entrante et sortante à portées de main</h2>
            <p>Connectez-vous pour continuer</p>
          </div>
          <div className={styles.auth_left_bottom}>
            <a href="https://manage-invoices.sahadevia.fr">
              https://manage-invoices.sahadevia.fr
            </a>
          </div>
        </div>
        <div className={styles.auth_right}>
          <div className={styles.auth_right_container}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
